//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'modelItem',
  props: ['resource', 'index', 'ratio', 'type', 'thumb', 'slug'],
  components: {
    thumb: () => import('~/components/thumb')
  },
  methods: {
    favorite(resource) {
      this.$emit('toggleFavorite', resource)
    }
  }
}
